import { CountResponse } from '@interfaces/common.interface';
import {
  CountMedicalDoctorsRequestParams,
  CreateMedicalDoctorRequestBody,
  GetMedicalDoctorsRequestParams,
  MedicalDoctor,
} from '@interfaces/medicalDoctors.interface';
import { UpdateMedicalOrganizationRequest } from '@interfaces/medicalOrganizations.interface';

import api from './';

export const {
  useGetMedicalDoctorByIdQuery,
  useCountMedicalDoctorsQuery,
  useGetManyMedicalDoctorsQuery,
  useCreateMedicalDoctorMutation,
  useUpdateMedicalDoctorMutation,
  useDeleteMedicalDoctorMutation,
  useLazyGetMedicalDoctorsXlsxQuery,
} = api.injectEndpoints({
  endpoints: (build) => ({
    getMedicalDoctorById: build.query<MedicalDoctor, string>({
      query: (id) => ({ url: `medical-doctors/${id}` }),
      providesTags: ['medicalDoctors'],
    }),
    countMedicalDoctors: build.query<
      CountResponse,
      CountMedicalDoctorsRequestParams
    >({
      query: (params) => ({ url: 'medical-doctors/count', params }),
      providesTags: ['medicalDoctors'],
    }),
    getManyMedicalDoctors: build.query<
      MedicalDoctor[],
      GetMedicalDoctorsRequestParams
    >({
      query: (params) => ({ url: 'medical-doctors', params }),
      providesTags: ['medicalDoctors'],
    }),
    createMedicalDoctor: build.mutation<
      MedicalDoctor,
      CreateMedicalDoctorRequestBody
    >({
      query: (body) => ({
        url: 'medical-doctors',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['medicalDoctors', 'users'],
    }),
    updateMedicalDoctor: build.mutation<
      MedicalDoctor,
      UpdateMedicalOrganizationRequest
    >({
      query: ({ id, body }) => ({
        url: `medical-doctors/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['medicalDoctors', 'users'],
    }),
    deleteMedicalDoctor: build.mutation<MedicalDoctor, string>({
      query: (id) => ({
        url: `medical-doctors/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['medicalDoctors', 'users'],
    }),
    getMedicalDoctorsXlsx: build.query<Blob, void>({
      query: () => ({
        url: 'medical-doctors/xlsx',
        responseHandler: async (response) => await response.blob(),
        cache: 'no-cache',
      }),
    }),
  }),
});
